import React, { useEffect, useState } from 'react';
import { fetchDashboardItems, updateExistingRecord, deleteExistingRecord } from '../api/dataService.js';
import { RECORD_STATUS } from '../config/fieldsConfig.js';
import DataTable from './DataTable'

export default function Dashboard({ dataType, tab, setSelectedRecord, setModalMode, refreshKey, triggerTabRefresh }) {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const today = new Date().toISOString().split('T')[0];
    fetchDashboardItems(today, RECORD_STATUS.ACTIVE)
      .then((records) => {
        const enhancedRecords = records.map( record => {
          let details = "" ;
          switch (record.dataType) {
            case "jobApplications":
              details = [
                record.companyName,
                record.jobTitle,
                record.jobID  ? `(${record.jobID})` : null
              ].filter(Boolean).join(": ");
              break;
            case "networking":
              details = record.contact || "";
              break;
            case "targetCompanies":
              details = record.company || "";
              break;
            case "events":
              details = [
                record.eventName,
                record.eventType ? `(${record.eventType})` : null
              ].filter(Boolean).join(" ");
              break;
            case "actionItems":
              details = record.actionItem || "";
              break;
            case "learning":
              details = [
                record.learningItem,
                record.learningType ? `(${record.learningType})` : null
              ].filter(Boolean).join(" ");
              break;
            default:
              details = "";
          }
          return{ ...record, details } ;
        });
        console.log("Dashboard Read Records:", enhancedRecords);
        setItems(enhancedRecords) ;
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
        alert("Failed to load dashboard items.");
        setIsLoading(false);
      }) ;
  }, [refreshKey]);

  if (isLoading) { return <center><h2>Fetching ... </h2></center>; };

  return (
    <>
      {isBusy && <div className="overlay-banner">Processing...</div>}
      <DataTable
        title={tab.label}
        data={items}
        fields={tab.fields}
        onView={(record) => {
          setSelectedRecord(record);
          setModalMode("view");
        }}
        onStateChange={ async (record) => {
          console.log( "Dashboard: state change called for:", record );
          if (record.recordStatus === RECORD_STATUS.ACTIVE)
            record.recordStatus = RECORD_STATUS.SNOOZED;
          else
            record.recordStatus = RECORD_STATUS.ACTIVE;
          setIsBusy(true);
          try {
            await updateExistingRecord( record.dataType, record );
          } catch (err) {
            console.error( "Status Change Failed:", err );
            alert( "Status Change Failed:" + err.message );
          } finally {
            setIsBusy(false);
            triggerTabRefresh();
          }
        }}
        onEdit={(record) => {
          setSelectedRecord(record);
          setModalMode("update") ;
        }}
        onDelete={async (record) => {
          console.log('delete called for:',record) ;
          if (window.confirm("Are you sure you want to delete this record?")) {
            setIsBusy(true);
            try {
              await deleteExistingRecord( record );
            } catch (err) {
              console.error("Delete failed:", err);
              alert("Delete failed: " + err.message);
            } finally {
              setIsBusy(false);
              triggerTabRefresh();
            }
          }
        }}
      />
    </>
  );
};


